module.exports = __webpack_public_path__ + "img/home_1.59e6c502.png";